<template>
  <v-container fluid>
    <v-row
        align="center"
        justify="center"
      >
        <v-col cols="12" sm="12" md="8">
          <v-skeleton-loader
            :loading="text === null"
            height="120"
            width="100%"
            type="card"
          >
            <v-textarea
              solo
              auto-grow
              v-model="text"
              label="Quote"
            ></v-textarea>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
      >
        <v-col cols="12" sm="12" md="8">
          <template v-if="bookChooserOpen">
            <BookChooser @hasbook="hasBook"/>
          </template>
          <template v-else>
            <div v-if="book">
              „{{ book.title }}“ by <i>{{ book.author }}</i>
            </div>
            <div v-else>
              No book chosen
            </div>
            <v-btn @click="bookChooserOpen = true">Choose Book</v-btn>
          </template>
        </v-col>
        <v-col cols="12" sm="12" md="8">
          <v-text-field
            type="number"
            inputmode="numeric"
            pattern="\d*"
            min="1"
            v-model="pageNumber"
            label="Page number"
            placeholder="Page number of quote"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
      >
        <v-col cols="12" sm="12">
          <v-combobox
            v-model="tags"
            :search-input.sync="tagInput"
            :items="allTags"
            cache-items
            chips
            hide-selected
            :filter="queryTags"
            clearable
            label="Tags"
            multiple
            solo
          >
            <template v-slot:no-data>
              <v-list-item v-if="tagInput">
                <v-list-item-content>
                  <v-list-item-title>
                    Press <kbd>enter</kbd> to create tag <strong>{{ tagInput }}</strong>.
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                @click="select"
                @click:close="removeTag(item)"
              >
                <strong>{{ item }}</strong>
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-textarea
            outlined
            name="note"
            label="Notes"
            v-model="notes"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
      <v-col cols="12" md="8">
        <v-btn @click="submitQuote" :disabled="!formValid" x-large block color="primary">
          {{ submitLabel }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BookChooser from '../components/BookChooser.vue'

export default {
  name: 'EditQuote',
  props: {
    quote: {
      type: Object,
      required: false
    },
    quoteText: {
      type: String,
      default: ''
    }
  },
  components: {
    BookChooser
  },
  data () {
    let d = {
      bookChooserOpen: false,
      cachedTags: [],
      tagInput: null
    }
    if (this.quote) {
      d = {
        ...d,
        text: this.quote.quote,
        pageNumber: this.quote.page_number,
        book: this.quote.book,
        notes: this.quote.notes,
        tags: this.quote.tags
      }
    } else {
      d = {
        ...d,
        text: this.quoteText || null,
        pageNumber: null,
        book: null,
        notes: '',
        tags: []
      }
    }
    return d
  },
  updated () {

  },
  computed: {
    books () {
      return this.$store.state.books
    },
    submitLabel () {
      if (this.quote) {
        return 'Edit quote'
      } else {
        return 'Add quote'
      }
    },
    formValid () {
      return this.text !== null && this.text.length > 0
    },
    allTags () {
      return this.$store.getters.allTags
    }
  },
  methods: {
    submitQuote () {
      const d = {
        quote: this.text,
        page_number: this.pageNumber,
        notes: this.notes,
        tags: this.tags.slice(),
        book: this.book,
        created: (new Date()).toISOString(),
        modified: (new Date()).toISOString()
      }
      let save
      if (this.quote) {
        d.id = this.quote.id
        d.created = this.quote.created
        save = this.$store.dispatch('updateQuote', d)
      } else {
        save = this.$store.dispatch('addQuote', d)
      }
      this.$emit('submit', save)
    },
    hasBook (book) {
      this.book = book
      this.bookChooserOpen = false
    },
    removeTag (item) {
      this.tags.splice(this.tags.indexOf(item), 1)
      this.tags = [...this.tags]
    },
    queryTags (item, queryText, itemText) {
      return itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    }
  },
  watch: {
    quoteText () {
      this.text = this.quoteText.trim()
    }
  }
}
</script>
